// Botões de controle da barra lateral: primeiro os do Tibia, depois a fileira do Baiak.
// Para um conteúdo novo, basta acrescentar uma linha aqui.

const IMG = '/assets/interface/images';
/** convite permanente do Discord oficial */
export const DISCORD_URL = 'https://discord.gg/EurJ67rqx';

export interface ControlButton {
  id: string;
  label: string;
  up: string;
  down?: string;
  group: 'tibia' | 'baiak';
  /** Descrição curta mostrada na janela enquanto o conteúdo não está pronto. */
  about: string;
}

const tibia = (id: string, label: string, file: string, about: string): ControlButton =>
  ({ id, label, group: 'tibia', up: `${IMG}/button-${file}-up.png`, down: `${IMG}/button-${file}-down.png`, about });
const tibiaIcon = (id: string, label: string, file: string, about: string): ControlButton =>
  ({ id, label, group: 'tibia', up: `${IMG}/skin/classic/${file}.png`, about });
const baiak = (id: string, label: string, about: string): ControlButton =>
  ({ id, label, group: 'baiak', up: `/ui/btn-${id}-up.png`, down: `/ui/btn-${id}-down.png`, about });

export const CONTROLS: ControlButton[] = [
  tibia('skills', 'Skills', 'skills', '__widget__'),
  tibia('spells', 'Lista de magias', 'spelllistwidget', 'Todas as magias e runas da sua vocation.'),
  tibia('battle', 'Battle List', 'battlelist', '__widget__'),
  tibia('cyclopedia', 'Cyclopedia', 'cyclopedia', 'Bestiário, charms, itens, mapa e informações do personagem.'),
  tibia('bosstiary', 'Bosstiary', 'bosstiary', 'Progresso contra os bosses e as recompensas do bosstiário.'),
  tibia('bossslots', 'Boss Slots', 'bossslots', 'Bosses equipados para bônus de loot, e o boss do dia.'),
  tibia('forge', 'Exaltation Forge', 'exaltation-forge', 'Fusão e transferência de tier dos itens.'),
  { id: 'proficiency', label: 'Weapon Proficiency', group: 'tibia', up: `${IMG}/icon-proficiencytree-open-button.png`, about: 'Proficiência de Armas: experiência e bônus de cada arma.' },
  tibia('highscores', 'Highscores', 'highscores', 'Rankings do servidor.'),
  tibia('rewardwall', 'Recompensa diária', 'rewardwall', 'Recompensa por login, com sequência de dias.'),
  tibia('analytics', 'Analytics', 'analyticsselector', 'Abre as janelas de análise da hunt.'),
  tibiaIcon('prey', 'Prey', 'icon-preydialogue', 'Bônus de prey por criatura.'),
  tibiaIcon('tasks', 'Tasks', 'icon-taskboard-button', 'Bounty Tasks, Weekly Tasks e Bounty Talisman.'),
  tibiaIcon('wheel', 'Wheel of Destiny', 'icon-skillwheeldialog', 'Wheel of Destiny e gemas.'),
  tibia('quests', 'Quest Log', 'questlog', 'Quests clássicas do Tibia: Annihilator, Demon Helmet, Inquisition e outras.'),
  tibia('vip', 'VIP', 'viplist', 'Lista de amigos.'),
  tibia('party', 'Party', 'battlelist-party', 'Grupo de caça com XP compartilhada.'),
  tibia('social', 'Social', 'social', 'Amigos, guild e mensagens.'),

  baiak('hunts', 'Hunts', 'Escolha a cave, o andar e a rota, e entre pelo teleporte.'),
  baiak('bosses', 'Bosses', 'Salas dos bosses, com os cooldowns do Tibia.'),
  baiak('fendas', 'Fendas', 'Dungeons por tier de level, sozinho ou com a party.'),
  baiak('treino', 'Treino', 'Sua sala de treino com training monk, e o treino offline.'),
  baiak('torre', 'Torre Infinita', 'Andares sem fim, cada vez mais fortes, com um guardião a cada 10 andares.'),
  baiak('labirinto', 'Labirinto do Caos', 'Ache os baús do labirinto e derrote o Guardião do Caos.'),
  baiak('wild', 'Wild Hunts', 'Descampado aberto da sua faixa de level: monstros mais fortes, +50% de XP e loot, 1 hora por dia.'),
  baiak('coliseu', 'Coliseu', 'Waves infinitas, ranking mensal e marcas do Coliseu.'),
  baiak('heroi', 'PvP e Herói', 'Fila de batalha contra a mesma vocation e o Herói do ciclo.'),
  baiak('expedicoes', 'Expedições', 'Ecos de vocation em expedições.'),
  baiak('guild', 'Guild e Cerco', 'Sede, boss de guild e cerco de castelo.'),
  baiak('ameaca', 'Ameaça mundial', 'Boss com barra de vida de todo o servidor.'),
  baiak('reset', 'Reset', 'Reset de level com bônus acumulado, até 10 vezes.'),
  baiak('imbuir', 'Imbuements', 'Imbuements do Tibia: itens de criatura dão bônus temporários aos equipamentos.'),
  baiak('refine', 'Refine', 'Refine de +1 a +30 e pedras de proteção.'),
  baiak('cards', 'Cards', 'Cartas das criaturas, liberadas no bestiário.'),
  baiak('outfits', 'Outfits e Montarias', 'Outfits, addons e montarias, e o que falta para cada um.'),
  baiak('depot', 'Depot', 'Seus itens guardados.'),
  baiak('mercado', 'Mercado', 'Compra e venda entre jogadores.'),
  baiak('casas', 'Casas', 'Casas de Noxara: leilão, aluguel, decoração e convidados.'),
  baiak('roleta', 'Roleta', 'Roleta de prêmios.'),
  baiak('eventos', 'Eventos', 'Calendário de eventos do servidor.'),
  baiak('discord', 'Discord do Baiak: Noxara', 'Avisos, changelog, suporte e wiki.'),
];
